import { useState } from "react";
import { ArrowRight, Check, Phone, Play } from "lucide-react";
import CalendlyModal from "@/components/CalendlyModal";
import { Analytics } from "@/lib/analytics";
import { signupUrl } from "@/lib/productApp";

const agencyPortrait = "/hero.png";

const Hero = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="pt-[72px]">
      <div className="mx-auto max-w-[1440px] px-5 md:px-8 lg:px-12">
        <div className="grid overflow-hidden border-x border-border lg:grid-cols-12">
          <div className="relative z-10 flex min-h-[640px] flex-col justify-center px-5 py-14 md:px-10 lg:col-span-7 lg:min-h-[660px] lg:px-14 lg:py-20">
            <p className="eyebrow mb-7">Conçu pour les agences immobilières</p>
            <h1 className="display-title max-w-[760px] text-[48px] sm:text-[64px] lg:text-[74px] xl:text-[84px]">
              Chaque appel peut être <span className="text-primary">une affaire.</span>
            </h1>
            <p className="mt-7 max-w-[610px] text-[17px] leading-7 text-foreground/65 md:text-lg md:leading-8">
              Immovox décroche quand votre équipe ne peut pas, comprend le projet immobilier et prépare un rappel avec le contexte utile.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a href={signupUrl()} onClick={() => Analytics.ctaClicked("demarrer_essai", "hero")} className="btn-primary">
                Tester Immovox <ArrowRight className="h-4 w-4" />
              </a>
              <button onClick={() => { Analytics.ctaClicked("planifier_demo", "hero"); setOpen(true); }} className="btn-secondary">
                <Play className="h-4 w-4 text-primary" /> Voir une démo
              </button>
            </div>
            <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-[13px] text-muted-foreground">
              {["7 jours gratuits", "Sans engagement", "Votre numéro reste le même"].map((item) => (
                <span key={item} className="flex items-center gap-2"><Check className="h-3.5 w-3.5 text-primary" />{item}</span>
              ))}
            </div>
          </div>

          <div className="relative min-h-[540px] overflow-hidden border-t border-border lg:col-span-5 lg:min-h-[660px] lg:border-l-0 lg:border-t-0">
            <img
              src={agencyPortrait}
              alt="Professionnelle de l'immobilier en relation avec un client"
              className="absolute inset-0 h-full w-full object-cover object-[62%_center]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground/32 via-transparent to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 left-0 hidden w-40 bg-gradient-to-r from-background via-background/80 to-transparent lg:block" />

            <div className="absolute bottom-7 left-7 right-7 bg-background/[.985] p-4 shadow-warm-lg ring-1 ring-foreground/[.04] md:bottom-8 md:left-8 md:right-8">
              <div className="flex items-center justify-between gap-4 border-b border-border pb-3">
                <div className="flex items-center gap-3">
                  <span className="flex h-8 w-8 items-center justify-center bg-primary text-primary-foreground"><Phone className="h-4 w-4" /></span>
                  <div>
                    <p className="text-xs text-muted-foreground">Appel qualifié</p>
                    <p className="text-sm font-semibold">Projet de vente · Toulouse</p>
                  </div>
                </div>
                <span className="font-mono text-[10px] uppercase tracking-wider text-primary">À rappeler</span>
              </div>
              <p className="mt-3 text-[15px] leading-6">« Je souhaite faire estimer mon appartement dans les trois prochains mois. »</p>
              <div className="mt-3 grid grid-cols-3 gap-3 text-xs">
                <div><span className="block text-muted-foreground">Profil</span><b>Vendeur</b></div>
                <div><span className="block text-muted-foreground">Motif</span><b>Estimation</b></div>
                <div><span className="block text-muted-foreground">Délai</span><b>&lt; 3 mois</b></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-y border-border">
        <div className="mx-auto grid max-w-[1344px] grid-cols-2 md:grid-cols-4">
          {[["01","Estimation"],["02","Acquisition"],["03","Location"],["04","Gestion"]].map(([n,x]) => (
            <div key={x} className="flex items-center gap-3 border-r border-border px-5 py-5 last:border-r-0 md:px-8">
              <span className="font-mono text-[10px] text-primary">{n}</span><span className="text-sm font-medium">{x}</span>
            </div>
          ))}
        </div>
      </div>
      <CalendlyModal open={open} onOpenChange={setOpen} source="hero" />
    </section>
  );
};
export default Hero;